import { render } from "./AdmobIntegrationSettings.vue?vue&type=template&id=3d0b51d4"
import script from "./AdmobIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./AdmobIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__